module.exports = __webpack_public_path__ + "static/media/maintenance.db5ef63e.svg";